const optionTypes = {
	TEXT: 'TEXT',
	BOOLEAN: 'BOOLEAN',
};

export default optionTypes;
